import React from 'react';

const Blog = () => {
    return (
        <div>
            <h2 style={{textAlign:'center', marginTop:'2rem'}}>This page is in under construction...</h2>
        </div>
    );
};

export default Blog;